import { User, UserService } from '@ospace/auth'
import { useQuery } from 'react-query'

export const useUsers = () => {
  return useQuery<User[]>('users', UserService.getUsers)
}
